package org.matthewo.api

import kotlinx.serialization.Serializable
import org.matthewo.schema.StandardMetrics

@Serializable
data class EventCompetition<N : Number, out M : MetricsAPI<N>?>(
    val event: String,
    val number: Int,
    val name: String,
    val new: Boolean,
    val opr: M,
    val oprn: M,
    val mean: M,
    val stdev: M,
    val min: M,
    val max: M,
)

@Serializable
sealed interface MetricsAPI<N : Number> : StandardMetrics<N> {
    abstract override val total: N
    abstract override val npTotal: N
    abstract override val auto: N
    abstract override val teleop: N
    abstract override val endgame: N
    abstract override val penalty: N
}

@Serializable
data class StandardMetricsAPI<N : Number>(
    override val total: N,
    override val npTotal: N,
    override val auto: N,
    override val teleop: N,
    override val endgame: N,
    override val penalty: N,
) : MetricsAPI<N>
